import Table from "components/DataTable/Table";
import Spinner from "components/Spinner";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import * as XLSX from "xlsx";

import { useSearchParams } from "react-router-dom";
import {
  getColorsArrayByIds,
  GetNameWithTimeStamp,
  truncateString,
} from "utils/UtilityFuncs";
import AddFromPreviousWorkOrder from "./AddFromPrevious/AddFromPreviousWorkOrder";
import SOAddUpdateProduct from "./AddUpdateProduct/SOAddUpdateProduct";
import UploadImagesButton from "./UploadImagesButton";
import Email from "./email";
import ImportWOProductsExcel from "./ImportWOProductsExcel";
import WOProductAdd from "./WOProductAdd";
import WOProductUpdate from "./WOProductUpdate";
import DeleteModalButton from "components/DeleteModalBtn/DeleteModalButton";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { setNotification } from "features/Notification/notificationSlice";
import BulkWProductDelete from "./BulkWProductDelete";

function WOProducts({
  refreshFunc,
  selectedWorkOrder,
  allProducts,
  setAllProducts,
}) {
  const user = useSelector((state) => state.user?.userInfo);
  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();

  /*   ALL STATES
   ********************************************* */
  const [filterBy, setFilterBy] = useState({ name: "All", value: null });
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showSelectProductModal, setShowSelectProductModal] = useState(false);
  const [showExcelImportModal, setShowExcelImportModal] = useState(false);

  const [showEditModalAfterImport, setShowEditModalAfterImport] =
    useState(null);
  const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);

  const [selected, setSelected] = useState(null);
  const [lastSortId, setLastSortId] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productFilter, setProductFilter] = useState("All");

  const [approvalData, setApprovalData] = useState("loading");
  const [approvalStatus, setApprovalStatus] = useState({
    badgeClass: "bg-secondary text-white",
    badgeText: "Not Sent",
    badgeStyle: {},
  });

  const [filteredProducts, setFilteredProducts] = useState(null);

  const [approvalColorsMap, setApprovalColorsMap] = useState(null);

  const [productTypes, setProductTypes] = useState(null);

  /*   All Functions
   ********************************************* */
  function loadingOn() {
    setLoading(true);
  }

  function loadingOff() {
    setLoading(false);
  }

  const setUpdateId = (id) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("productId", id);
      return newParams.toString();
    });
  };

  const removeUpdateId = () => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.delete("productId");
      return newParams.toString();
    });
  };

  // get All ProductTypes
  const getAllProductTypes = async () => {
    try {
      const { data } = await API.get("/productTypes", {
        headers: authHeader(),
      });
      setProductTypes(data);
    } catch (err) {
      console.error(err);
    }
  };

  const HandleDuplicateProduct = async (product) => {
    delete product.id;
    delete product.WOId;
    delete product.createdAt;
    delete product.updatedAt;
    delete product.sortId;

    product.approveStatus = "pending";
    delete product?.approvedTime;
    delete product?.approvalComments;

    product.sendNameApproval = false;
    product.requireNames = "no";
    product.sendNumberApproval = false;
    product.requireNumbers = "no";

    // delete item.totalPrice;
    // delete item.totalQuantity;

    let bodyData = {
      ...product,
      sortId: lastSortId + 1,
      WOId: selectedWorkOrder?.id,
      duplicateProductImg: product?.productImage
        ? GetNameWithTimeStamp(product?.productImage)
        : null,
    };

    loadingOn();
    try {
      // Assigning update data to formData in JSON string

      const { data } = await API.post(`/wo-products/duplicate`, bodyData, {
        headers: authHeader(),
      });

      if (data?.success) {
        await refreshFunc();
        // showAddPage(false);
        loadingOff();
        return;
      }
      loadingOff();
    } catch (err) {
      alert(err.message);
      loadingOff();
    }
  };

  // Delete WorkOrders
  const deleteWOProduct = async (id) => {
    try {
      const { data } = await API.delete(`/wo-products/delete/${id}`, {
        headers: authHeader(),
      });
      if (data?.message?.type === "success") {
        await refreshFunc();
        setSelected(null);
        return;
      } else {
        console.log(data);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  // Sorting Up
  const sortUp = async (id) => {
    const index = allProducts.findIndex((product) => product.id === id);

    const currentSortId = allProducts[index]?.sortId;
    const currentId = allProducts[index]?.id;
    const upSortId = allProducts[index - 1].sortId;
    const upId = allProducts[index - 1].id;
    try {
      const { data } = await API.post(
        "/wo-products/sortup",
        { currentSortId, currentId, upSortId, upId },
        { headers: authHeader() },
      );
      if (data.success) {
        refreshFunc();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  // Sorting Up
  const sortDown = async (id) => {
    const index = allProducts.findIndex((product) => product.id === id);

    const currentSortId = allProducts[index]?.sortId;
    const currentId = allProducts[index]?.id;
    const downSortId = allProducts[index + 1].sortId;
    const downId = allProducts[index + 1].id;
    try {
      const { data } = await API.post(
        "/wo-products/sortDown",
        { currentSortId, currentId, downSortId, downId },
        { headers: authHeader() },
      );
      if (data.success) {
        refreshFunc();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  const getLastSortId = (products) => {
    return products[products.length - 1]?.sortId + 1 || 1;
  };

  function createAndDownloadExcel() {
    const productTypesList = productTypes.map((productType) => {
      let newItem = [productType.productTypes];
      return newItem;
    });

    // Create new workbook
    const workbook = XLSX.utils.book_new();

    // Create data for wo_products sheet
    const productSheetColumns = [
      [
        "productType",
        "productStyle",
        "productColor",
        "productDescription",
        "productFabric",
        "teamName",
        "notes",
      ],
    ];

    const woProductsWorksheet = XLSX.utils.aoa_to_sheet(productSheetColumns);
    XLSX.utils.book_append_sheet(workbook, woProductsWorksheet, "wo_products");

    // Create data for productTypes sheet
    const productTypesData = [["Product Types"], ...productTypesList];
    const productTypesWorksheet = XLSX.utils.aoa_to_sheet(productTypesData);
    XLSX.utils.book_append_sheet(
      workbook,
      productTypesWorksheet,
      "productTypes",
    );

    // Generate Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Create a blob and download
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Sample-WoProduct-ImportFile.xlsx";
    link.click();

    // Clean up
    URL.revokeObjectURL(url);
  }

  function getProductTypeList(allProducts) {
    let productTypeList = [];
    allProducts.forEach((product) => {
      if (!productTypeList.includes(product.productType)) {
        productTypeList.push(product.productType);
      }
    });
    return productTypeList || [];
  }

  function handleProductTpeChange(value) {
    const selectedType = value;
    if (selectedType === "All") {
      setFilteredProducts(allProducts);
    } else {
      const filtered = allProducts.filter(
        (product) => product.productType === selectedType,
      );
      setFilteredProducts(filtered);
    }
  }

  // get approval Data by woId
  const getApprovalData = async (woId) => {
    try {
      setLoading(true);
      const { data } = await API.get(`/wo-lot-approvals/${woId}`, {
        headers: authHeader(),
      });
      if (data?.success) {
        setApprovalData(data?.data || null);
      } else {
        setApprovalData(null);
        dispatch(
          setNotification({
            message: data?.message || "Failed to fetch approval data",
            type: "error",
          }),
        );
      }
      setLoading(false);
      return data.data;
    } catch (err) {
      setLoading(false);
      setApprovalData(null);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  /*   ALL UseEffects
   ********************************************* */
  useEffect(() => {
    if (allProducts) {
      setLastSortId(
        allProducts[allProducts?.length - 1]?.sortId
          ? allProducts[allProducts?.length - 1]?.sortId
          : 0,
      );
    }
    // getWorkOrdersProducts();
    setSelected(null);
  }, [allProducts, showUpdateModal, showAddModal]);

  useEffect(() => {
    if (!showUpdateModal) {
      removeUpdateId();
    }
  }, [showUpdateModal]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      getAllProductTypes();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div className="d-flex">
      {(user?.permissions?.includes("work_orders_add") ||
        user?.permissions?.includes("work_orders_dataEntry") ||
        user?.roles === "admin") && (
        <>
          <Dropdown className="ms-1">
            <Dropdown.Toggle
              className="no-icon px-1"
              variant="success"
              id="dropdown-wo-product-actions"
            >
              <i className="mdi mdi-dots-vertical"></i>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                as="button"
                type="button"
                className="text-start"
                onClick={() => {
                  setShowSelectProductModal(true);
                }}
              >
                Add From Previous WO
              </Dropdown.Item>

              <Dropdown.Item as="button" type="button" className="text-start">
                <UploadImagesButton
                  refreshFunc={refreshFunc}
                  selectedWorkOrder={selectedWorkOrder}
                  allProducts={allProducts}
                />
              </Dropdown.Item>

              <Dropdown.Item as="button" type="button" className="text-start">
                <BulkWProductDelete
                  allProducts={allProducts}
                  refreshFunc={refreshFunc}
                />
              </Dropdown.Item>

              <Dropdown.Item
                as="button"
                type="button"
                className="text-start"
                onClick={() => {
                  setShowExcelImportModal(true);
                }}
              >
                Import From Excel
              </Dropdown.Item>

              {productTypes && (
                <Dropdown.Item
                  as="button"
                  type="button"
                  className="text-start"
                  onClick={() => {
                    createAndDownloadExcel();
                  }}
                >
                  <i className="mdi mdi-download me-1"></i>Sample File
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
          <button
            onClick={() => {
              setShowAddUpdateModal(true);
              // setShowAddModal(true);
            }}
            type="button"
            className="btn btn-primary  ms-1"
          >
            ADD Product
          </button>
        </>
      )}
    </div>
  );

  let filterByOptions = [
    { name: "Product Type", value: "productType" },
    { name: "Product Style", value: "productStyle" },
    { name: "Product Color", value: "productColor" },
    { name: "Product Description", value: "productDescription" },
    { name: "Team Name", value: "teamName" },
    { name: "Total Quantity", value: "totalQuantity" },
  ];

  const buttons = () => (
    <div className=" d-flex justify-content-end align-items-center gap-1 me-1">
      <h4 className="me-1">Product Type Filter : </h4>
      <DropdownButton
        variant="primary"
        id="dropdown-product"
        title={`Filter By: ${productFilter}`}
      >
        <Dropdown.Item onClick={() => setProductFilter("All")}>
          Filter by All
        </Dropdown.Item>
        {getProductTypeList(allProducts)?.map((type) => (
          <Dropdown.Item key={type} onClick={() => setProductFilter(type)}>
            {type}
          </Dropdown.Item>
        ))}
      </DropdownButton>

      {/* Search Filters */}
      <DropdownButton
        className=""
        variant="outline-primary"
        title={filterBy ? `Search By: ${filterBy?.name}` : "Search by All"}
        id="dropdown-search-by"
      >
        <Dropdown.Item onClick={() => setFilterBy(null)}>
          Search by All
        </Dropdown.Item>
        {filterByOptions.map((option) => (
          <Dropdown.Item key={option.value} onClick={() => setFilterBy(option)}>
            {option.name}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </div>
  );

  // Click a heading to sort (user, 2026-11-03).
  const table_head = [
    { name: "Item No", value: "sortId" },
    { name: "Type", value: "productTypes.productTypes" },
    { name: "Style", value: "productStyle" },
    { name: "Description", value: "productDescription" },
    { name: "Color", value: "productColor" },
    { name: "Team Name", value: "teamName" },
    { name: "Quantity", value: "totalQuantity" },
    { name: "Is Ready", value: "isReady" },
    { name: "Actions", value: "Actions" },
  ];

  const table_body = (item, index) => (
    <tr
      onClick={() => setSelected(item)}
      className={selected?.id === item.id ? "bg-primary bg-opacity-25" : ""}
      key={item.id}
      onDoubleClick={() => {
        setShowAddUpdateModal(true);
        setUpdateId(item?.id);
      }}
    >
      <td className="py-0 align-middle">{item.sortId} </td>
      <td className="py-0 align-middle">
        {item?.productTypes?.productTypes || "No product type selected"}
      </td>
      <td className="py-0 align-middle">{item.productStyle}</td>
      <td className="py-0 align-middle">{item.productDescription} </td>

      <td className="py-0 align-middle">
        {approvalColorsMap && item.approvalColors.length > 0
          ? truncateString(
              item.approvalColors
                .map((colorId) => approvalColorsMap[parseInt(colorId)])
                .join(", "),
              20,
            )
          : truncateString(item.productColor, 30)}{" "}
        {/* {JSON.stringify(approvalColorsMap)} */}
      </td>
      {/* <td className="py-0 align-middle">{item.teamName} </td> */}
      <td className="py-0 align-middle">{item.teamName} </td>
      <td className="py-0 align-middle">{item.totalQuantity} </td>
      <td className="py-0 align-middle">{item.isReady ? "Yes" : "No"} </td>
      <td className="table-action align-middle py-0">
        <div
          onClick={() => {
            item.sortId !== 1 && sortUp(item.id);
          }}
          className="action-icon"
          style={{ cursor: "pointer" }}
        >
          <i className="mdi mdi-chevron-double-up"></i>
        </div>
        <div
          onClick={() => {
            item.sortId !== allProducts?.length && sortDown(item.id);
          }}
          className="action-icon"
          style={{ cursor: "pointer" }}
        >
          <i className="mdi mdi-chevron-double-down"></i>
        </div>
        {(user?.permissions?.includes("work_orders_update") ||
          user?.permissions?.includes("work_orders_dataEntry") ||
          user?.roles === "admin") && (
          <div className="action-icon">
            <i
              onClick={() => {
                // setShowUpdateModal(true);
                setShowAddUpdateModal(true);
                setUpdateId(item?.id);
              }}
              className="mdi mdi-pencil"
            ></i>
          </div>
        )}
        {(user?.permissions?.includes("work_orders_add") ||
          user?.permissions?.includes("work_orders_dataEntry") ||
          user?.roles === "admin") && (
          <div className="action-icon">
            <i
              onClick={() => {
                HandleDuplicateProduct(item);
              }}
              className="mdi mdi-content-duplicate"
            ></i>
          </div>
        )}
        {(user?.permissions?.includes("work_orders_delete") ||
          user?.permissions?.includes("work_orders_dataEntry") ||
          user?.roles === "admin") && (
          <DeleteModalButton
            deleteFunc={deleteWOProduct}
            deleteParams={item.id}
            btnClass={"btn btn-lg py-0 pb-1 px-0"}
            confirmText={`Do you want to delete Item#${item.sortId} - ${item.productStyle}?`}
          />
        )}
      </td>
    </tr>
  );

  const checkForPartialApproved = (approval) => {
    /**
       * Check for following conditions to check if partially approved
       *    { allApproved: true },
            { hasRejected: true },
            { approvalColorStatus: { [Op.ne]: "pending_approval" } },
            { excelFileStatus: { [Op.ne]: "pending_approval" } },
            { shippingAddressStatus: { [Op.ne]: "pending_approval" } },
            { inHandByDate: { [Op.ne]: null } },
            Not all of the products should have pending status
       */
    let partiallyApproved = false;
    if (approval.hasRejected) {
      partiallyApproved = true;
    } else if (
      approval.excelFileStatus !== "pending_approval" ||
      approval.shippingAddressStatus !== "pending_approval" ||
      approval.inHandByDate !== null
    ) {
      partiallyApproved = true;
    }

    // check if any of the products are not pending approval
    const products = approval?.WorkOrder?.WOProducts;
    if (products && products.length > 0) {
      const nonPendingProducts = products.filter(
        (prod) => prod.approveStatus !== "pending",
      );
      if (nonPendingProducts.length > 0) {
        partiallyApproved = true;
      }
    }
    if (approval.allApproved) {
      partiallyApproved = false;
    }

    return partiallyApproved;
  };

  const hasAnyRejectedStatus = (approval) => {
    if (approval?.hasRejected) return true;

    if (approval?.excelFileStatus === "rejected") return true;
    if (approval?.shippingAddressStatus === "rejected") return true;

    const products = approval?.WorkOrder?.WOProducts;
    if (products && products.length > 0) {
      const hasRejectedProduct = products.some(
        (prod) => prod.approveStatus === "rejected",
      );
      if (hasRejectedProduct) return true;
    }

    return false;
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      handleProductTpeChange(productFilter);
    }, 50);
    return () => clearTimeout(timeout);
  }, [productFilter, allProducts]);

  useEffect(() => {
    if (!showAddUpdateModal) {
      removeUpdateId();
    }
  }, [showAddUpdateModal]);

  useEffect(() => {
    if (showEditModalAfterImport) {
      setUpdateId(showEditModalAfterImport);
      setShowAddUpdateModal(true);
    }
  }, [showEditModalAfterImport]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      let allProductsCombineColorIds = new Set();
      allProducts?.map((product) => {
        if (product.approvalColors) {
          product.approvalColors.forEach((colorId) =>
            allProductsCombineColorIds.add(colorId),
          );
        }
      });

      if (allProductsCombineColorIds.size > 0) {
        const colorIdsArray = Array.from(allProductsCombineColorIds);
        getColorsArrayByIds(colorIdsArray)
          .then((colorArr) => {
            let colorMap = {}; // {id: name}
            colorArr.forEach((color) => {
              colorMap[color.colorId] = color.name;
            });
            setApprovalColorsMap(colorMap);
          })
          .catch((err) => {
            dispatch(
              setNotification({
                message: "Failed to fetch approval colors",
                type: "error",
              }),
            );
            setApprovalColorsMap(null);
          });
      } else {
        setApprovalColorsMap(null);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [allProducts]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      let woId = selectedWorkOrder?.woId || false;
      if (woId) {
        getApprovalData(woId);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [selectedWorkOrder]);

  useEffect(() => {
    if (approvalData && approvalData !== "loading") {
      const isRejected = hasAnyRejectedStatus(approvalData);
      const isPartiallyApproved = checkForPartialApproved(approvalData);

      let approvalBadgeClass = "bg-info text-white";
      let approvalBadgeText = "Pending";
      let approvalBadgeStyle;

      if (approvalData?.approvalEmailSent === false) {
        approvalBadgeClass = "bg-secondary text-white";
        approvalBadgeText = "Not Sent";
      } else if (isRejected) {
        approvalBadgeClass = "bg-danger text-white";
        approvalBadgeText = "Rejected";
      } else if (approvalData?.allApproved) {
        approvalBadgeClass = "bg-success text-white";
        approvalBadgeText = "Approved";
      } else if (isPartiallyApproved) {
        approvalBadgeClass = "border border-success border-3 text-dark";
        approvalBadgeText = "Partially";
        approvalBadgeStyle = { backgroundColor: "#ffff00" };
      }

      setApprovalStatus({
        badgeClass: approvalBadgeClass,
        badgeText: approvalBadgeText,
        badgeStyle: approvalBadgeStyle,
      });
    }
  }, [allProducts, approvalData]);

  if (!allProducts) return <Spinner />;

  return (
    <div className="d-flex flex-grow-1" style={{ height: "auto" }}>
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div
        className="px-3 d-flex flex-grow-1 "
        style={{ minHeight: "50vh", maxHeight: "80vh", borderRadius: 15 }}
      >
        <div className="horizontal-scrollable  d-flex flex-grow-1 ">
          {allProducts && (
            <Table
              filterBy={filterBy?.value || null}
              buttons={buttons}
              defaultLimit={999}
              btn1={btn1}
              table_head={table_head}
              columnSortable
              table_body={table_body}
              table_data={filteredProducts || allProducts}
              searchMaxWidth={300}
              tableSize={"sm"}
            />
          )}
        </div>
      </div>

      {/*   ADD Modal
       ********************************************* */}
      <Modal
        size="xl"
        show={showAddModal}
        // onHide={() => setShowAddModal(false)}
      >
        <Modal.Body>
          <div>
            <WOProductAdd
              selectedWorkOrder={selectedWorkOrder}
              showAddPage={setShowAddModal}
              refreshFunc={refreshFunc}
              lastSortId={lastSortId}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/*   Update Modal
       ********************************************* */}
      <Modal
        size="xl"
        show={showUpdateModal}
        // onHide={() => setShowUpdateModal(false)}
      >
        <Modal.Body>
          <div>
            <WOProductUpdate
              allProducts={allProducts}
              selectedWorkOrder={selectedWorkOrder}
              setShowUpdateModal={setShowUpdateModal}
              refreshFunc={refreshFunc}
              setUpdateId={setUpdateId}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/*   Email Modal
       ********************************************* */}
      <Modal
        size="lg"
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
      >
        <Modal.Body>
          {selectedWorkOrder && (
            <Email
              selectedWorkOrder={selectedWorkOrder}
              setShowEmailModal={setShowEmailModal}
            />
          )}
        </Modal.Body>
      </Modal>

      {/*   Add Update Modal
       ********************************************* */}
      <Modal
        size="xl"
        show={showAddUpdateModal}
        onHide={() => setShowAddUpdateModal(false)}
        contentClassName="bg-transparent"
      >
        <Modal.Body className="bg-light custom-border-radius">
          <SOAddUpdateProduct
            showModal={setShowAddUpdateModal}
            selectedWO={selectedWorkOrder}
            refreshFunc={refreshFunc}
            setUpdateId={setUpdateId}
            allProducts={allProducts}
            setAllProducts={setAllProducts}
            lastSortId={lastSortId}
            approvalStatus={approvalStatus}
            approvalData={approvalData}
          />
        </Modal.Body>
      </Modal>

      {/* UploadImages handled in UploadImagesButton component */}

      {/*   SelectProduct Modal
       ********************************************* */}
      <Modal
        size="lg"
        show={showSelectProductModal}
        onHide={() => setShowSelectProductModal(false)}
        contentClassName="bg-transparent"
      >
        <Modal.Body>
          <AddFromPreviousWorkOrder
            selectedWO={selectedWorkOrder}
            allProducts={allProducts}
            sortId={getLastSortId(allProducts)}
            refreshFunc={refreshFunc}
            showModal={setShowSelectProductModal}
            setShowEditModalAfterImport={setShowEditModalAfterImport}
          />
        </Modal.Body>
      </Modal>

      {/*   Import From Excel Modal
       ********************************************* */}
      <Modal
        size="lg"
        show={showExcelImportModal}
        onHide={() => setShowExcelImportModal(false)}
        contentClassName="bg-transparent"
      >
        <Modal.Body>
          <ImportWOProductsExcel
            selectedWO={selectedWorkOrder}
            refreshFunc={refreshFunc}
            showModal={setShowExcelImportModal}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default WOProducts;
